export * from './Contact';
export * from './Media';
export * from './UserInfo';
export * from './Folder';
export * from './Auction';
export * from './Files';

import {Contact} from './Contact';
import {Media} from './Media';
import {UserInfo} from './UserInfo';
import {Folder} from './Folder';
import {Platform} from 'react-native';
import {useFolders} from '../hooks/useFolders';
import {useFolder} from '../hooks/useFolder';

export enum FTSIndex {
  title = 'titleFTSIndex',
  name = 'nameFTSIndex',
  text = 'textFTSIndex',
}

export interface DocsGeneric {
  docs: (Folder | Media | Contact | UserInfo)[];
  rows: {
    _id: string;
    doc: Folder | Media | Contact | UserInfo;
  }[];
}

export interface Device {
  id: string;
  manufacturer: string;
  createdAt: number;
  isDevice: boolean;
  model: string;
  ip?: string;
  userAgent: string;
  os: string;
  platform: typeof Platform.OS;
}

export type DataHook = ReturnType<
  typeof useFolders | typeof useFolder
>;

export type DataHookFolders = ReturnType<typeof useFolders>;

export type DocsGenericArray = (
  | Folder
  | Media
  | Contact
  | UserInfo
)[];

export type FolderPreviewContentType = Media | Contact | Folder;
